import React from "react";
import { Button, Result } from "antd";
import { useHistory } from "react-router";
import routesConfig from "../../routesConfig";
import { useLayoutHeader } from "../../components/MainLayout";

const headerConfig = {
    pageTitle: "وضعیت پرداخت",
    closeable: false,
    menuEnabled: false,
    extra: [],
}

function PurchaseCallback(props) {
    const history = useHistory();
    useLayoutHeader(headerConfig)
    const onReturn = () => {
        if (window.opener != null && !window.opener.closed) {
            window.close()
        } else {
            history.push(routesConfig.home);
        }
    }
    const succeed = new URLSearchParams(props.location.search).get("succeed");
    const message = new URLSearchParams(props.location.search).get("message");

    const title = (succeed === "true") ? "خرید موفق" : "خرید ناموفق";
    const status = (succeed === "true") ? "success" : "error";

    return <>
        <Result className='mt-3'
            status={status}
            title={title}
            subTitle={message}
            extra={[
                <Button type="primary" block key="console" onClick={onReturn}>
                    بازگشت
                </Button>,
            ]}
        />
    </>;
}

export default PurchaseCallback;